import { mdiThumbUpOutline } from '@mdi/js'
import { useTranslation } from 'react-i18next'

import { Box } from '@/components/ui/box'
import EmptyState from '@/pages/components/tasksApprovals/mainContent/emptyState'
import ItemsList from '@/pages/components/tasksApprovals/mainContent/list'
import { ICompliance } from '@/types/tasksApprovals'

const TasksTab = ({ tasks }: { tasks: ICompliance[] }) => {
    const { t } = useTranslation()
    return (
        <Box display="flex" flex="1" flexDirection="column">
            {tasks.length > 0 && (
                <Box h="100%" overflow="auto">
                    <ItemsList items={tasks} type="tasks" />
                </Box>
            )}
            {tasks.length === 0 && (
                <EmptyState
                    title={t('tasksApprovals.empty.noData.title')}
                    message={t('tasksApprovals.empty.noData.message')}
                    icon={mdiThumbUpOutline}
                    iconColor="var(--chakra-colors-tertiary-green-500)"
                />
            )}
        </Box>
    )
}

export default TasksTab
